export const calculateTotalPosts = (data) => {
  // Sum up all posts across the provided data
  return data.reduce((sum, item) => sum + (item.posts?.length || 0), 0);
};

export const calculateTotalReactions = (data) => {
  // Sum up likes and comments for all posts
  return data.reduce(
    (sum, item) =>
      sum +
      (item.posts?.reduce(
        (postSum, post) =>
          postSum +
          (post.postMetrics?.likes || 0) +
          (post.postMetrics?.comments || 0),
        0
      ) || 0),
    0
  );
};

export const calculateTotalViews = (data) => {
  // Sum up view counts from all posts in the dataset.
  // Checks for postMetrics.views (General Post/Instagram/Facebook) and videoMetrics.viewCount (YouTube).
  return data.reduce(
    (sum, item) =>
      sum +
      (item.posts?.reduce(
        (postSum, post) =>
          postSum +
          (post.postMetrics?.views || 0),
        0
      ) || 0),
    0
  );
};
/**
 * Calculates the total impressions by summing 'profileMetrics.impressions' across all daily data points.
 * @param {Array<Object>} data - Array of daily data objects.
 * @returns {number} The total number of impressions.
 */
export const calculateTotalImpressions = (data) => {
  if (!Array.isArray(data)) {
    console.error("Invalid data passed to calculateTotalImpressions:", data);
    return 0;
  }

  return data.reduce(
    (sum, item) => sum + (item.profileMetrics?.impressions || 0),
    0
  );
};

/**
 * Calculates the total reach by summing 'profileMetrics.reach' across all daily data points.
 * @param {Array<Object>} data - Array of daily data objects.
 * @returns {number} The total reach.
 */
export const calculateTotalReach = (data) => {
  if (!Array.isArray(data)) {
    console.error("Invalid data passed to calculateTotalReach:", data);
    return 0;
  }

  return data.reduce(
    (sum, item) => sum + (item.profileMetrics?.reach || 0),
    0
  );
};
